import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String
  }

  copy(event) {
    event.preventDefault()
    
    const textToCopy = this.textValue || this.element.textContent
    
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.showFeedback(event.currentTarget)
        })
        .catch(err => {
          console.error('Failed to copy:', err)
          this.fallbackCopy(textToCopy)
        })
    } else {
      this.fallbackCopy(textToCopy)
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    
    try {
      document.execCommand('copy')
      this.showFeedback(event.currentTarget)
    } catch (err) {
      console.error('Fallback copy failed:', err)
    }
    
    document.body.removeChild(textarea)
  }

  showFeedback(button) {
    const originalText = button.innerHTML
    button.innerHTML = `
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      Copied!
    `
    
    setTimeout(() => {
      button.innerHTML = originalText
    }, 2000)
  }
}

